import { applyProgressEpoch } from '~/utils/progressEpoch'
import { ACCOUNT_DELETION_SESSION } from '~/utils/accountDeletion'

/**
 * 🧨 Runs the progress wipe BEFORE anything reads storage.
 *
 * Native Preferences restore completes first, then `enforce: 'pre'` ensures every composable that
 * holds progress (useStardust, useAscension, useOwnedCreatures,
 * useCollection, usePuzzleGame) lazily loads from localStorage the first
 * time it is touched, and the persistence plugin restores a saved run on
 * startup. If the wipe landed after any of those, the old values would
 * already be in memory and would be written straight back out.
 */
export default defineNuxtPlugin({
  name: 'progress-epoch',
  enforce: 'pre',
  dependsOn: ['native-persistence'],
  setup() {
    if (ACCOUNT_DELETION_SESSION) return
    applyProgressEpoch()
  },
})
